export default __webpack_public_path__ + "d12c45daca517256e77170f02cc27294.png";